import React from 'react';
import Icon from '../../../components/AppIcon';

const EventEntry = ({ event, onEventClick }) => {
  const getEventColor = () => {
    const now = new Date();
    const eventDate = event?.date;
    const timeDiff = eventDate - now;
    const hoursDiff = timeDiff / (1000 * 60 * 60);

    // Check if overdue
    if (event?.status === 'overdue' || timeDiff < 0) {
      return 'bg-red-100 dark:bg-red-900/20 text-red-600 dark:text-red-400 border-red-200 dark:border-red-800';
    }

    // Check if within 24 hours
    if (hoursDiff > 0 && hoursDiff <= 24) {
      return event?.type === 'appointment' ?'bg-green-100 dark:bg-green-900/20 text-green-600 dark:text-green-400 border-green-200 dark:border-green-800' :'bg-green-100 dark:bg-green-900/20 text-green-600 dark:text-green-400 border-green-200 dark:border-green-800';
    }

    // Default colors by type
    if (event?.type === 'appointment') {
      return 'bg-blue-100 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 border-blue-200 dark:border-blue-800';
    }
    
    return 'bg-yellow-100 dark:bg-yellow-900/20 text-yellow-600 dark:text-yellow-400 border-yellow-200 dark:border-yellow-800';
  };

  const getEventIcon = () => {
    return event?.type === 'appointment' ? 'Calendar' : 'Package';
  };

  const handleClick = (e) => {
    e?.stopPropagation();
    const rect = e?.currentTarget?.getBoundingClientRect();
    onEventClick(event, {
      top: rect?.top,
      left: rect?.left,
      width: rect?.width,
      height: rect?.height
    });
  };

  return (
    <div
      onClick={handleClick}
      className={`px-2 py-1 rounded text-xs font-medium border cursor-pointer hover:shadow-sm transition-smooth ${
        getEventColor()
      }`}
    >
      <div className="flex items-center gap-1 mb-0.5">
        <Icon name={getEventIcon()} size={10} />
        <span className="truncate">
          {event?.client || event?.project}
        </span>
      </div>
      <div className="text-[10px] opacity-80">
        {event?.time}
      </div>
    </div>
  );
};

export default EventEntry;